import { EType } from '@blade/common/interfaces/user-group';
export const userMapping = {
    [EType.USER]: 0,
    [EType.GUEST]: 1,
    [EType.BLACKLIST]: 2,
    [EType.STRANGER]: 4,
};
